import { Component, Input, OnInit } from '@angular/core';
import { eDateFormat } from '@hub/generated/enums';
import { CurrentUserService } from '@hub/services/CurrentUserService';

@Component({
  selector: 'g-columnDateTime',
  templateUrl: './columnDateTime.component.html',
})
export class ColumnDateTimeComponent implements OnInit {
  constructor(private userService: CurrentUserService) { }

  @Input() data: Date;
  @Input() isEditing: boolean = false;
  @Input() format: eDateFormat;

  ngOnInit() {
  }
}
